module.exports = __webpack_public_path__ + "img/PAK.5a9c622f.svg";